import ImageElementMetaData from './ImageElementMetaData';

const presets = [
  {
    type: ImageElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 200,
      height: 200
    },
    compProps: {
      zIndex: 1
    },
    data: {
      title: '',
      href: '',
      url: 'https://img.crazylister.com/7/images/templates/164108/camp7.png'
    },
    hidden: false
  }
];

export default presets;
